import { RiSearch2Line } from "react-icons/ri";
import '../style/store/S_Search.css';


const S_Search=()=>{
  return(
    <div className="s_search">
      <RiSearch2Line className="s_search_icon"/>
      <input type="search" name="ss_input" id="ss_input" className="s_search_input" placeholder="جستجو..." />
    </div>
  )
}

export default S_Search;